import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';
import Card from '../../components/Card/Card'
import CustomButton from "../../components/Custom-Button/CustomButton";
export default function Hearts() {

    return (
        <div>
            <NavBar/>
            <Title text={"Devoções Aos Santos Corações"}/>


            <div className="card-container">
            <Card Nome={"Imaculado Coração de Maria"} Imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Hearts/Mary.jpg"}/>

            <Card Nome={"Sagrado Coração de Jesus"} Imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Hearts/Jesus.png"}/>    
    
            <Card Nome={"Castíssimo Coração de São José"} Imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Hearts/Joseph.jpg"}/>
            </div>


            <div className="btn-row">
            <CustomButton route={"/Maria"} text={"Imaculado Coração de Maria"}/>
            <CustomButton route={"/Jesus"} text={"Sagrado Coração De Jesus"}/>
            <CustomButton route={"/Jose"} text={"Castíssimo Coração de São José"}/>
            </div>
   
            <Footer/>
        </div>
    )
}